import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';

@Pipe({
   name: 'stripHtml',
})
export class StripHtmlPipe implements PipeTransform {
   transform(value: string): string {
      if (_.isNil(value)) {
         value = '';
      }
      const doc = new DOMParser().parseFromString(value, 'text/html');
      return doc.body.textContent || '';
   }
}
